// extracted by mini-css-extract-plugin
export var columnList = "_ej-0";